















import { NetworkQuality } from "@share/web-conferences/types/NetworkQuality";
import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  name: "QualityIndicator"
})
export default class QualityIndicator extends Vue {
  @Prop({default: 0}) quality: NetworkQuality;
  @Prop({default: 100}) maxValue: number;
  @Prop({ default: 16 }) size: number;

  get poor() {
    return this.quality < 6;
  }

  get soSo() {
    return this.quality < 5;
  }

  get good() {
    return this.quality < 4;
  }

  get perfect() {
    return this.quality <= 2;
  }

  get unknown() {
    return this.quality === 0
  }

  get title() {
    if(this.quality === 1) {return this.$t("web-conferences.quality.good").toString();}
    if(this.quality >= 2 && this.quality <= 4) {return this.$t("web-conferences.quality.mayBeProblems").toString();}
    if(this.quality >= 5) {return this.$t("web-conferences.quality.bad").toString();}

    return ""
  }

  get color(): string{
    if (this.quality >= 5) {
      return 'is-red';
    }
    if (this.quality <= 4 && this.quality > 3) {
      return 'is-yellow';
    }
    return 'is-green';
  }

  get isOffline() {
    return this.quality === 6;
  }

}
